// frontend/src/utils/logger.js

/**
 * Frontend logger utility for consistent logging across the application
 */
class Logger {
  constructor(component = 'app') {
    this.component = component;
    this.isDevelopment = import.meta.env.DEV || false;
  }

  withComponent(component) {
    return new Logger(component);
  }

  formatMessage(level, message, data = {}) {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}] [${this.component}]`;

    if (typeof message === 'object') {
      return { prefix, message: JSON.stringify(message), data };
    }

    return { prefix, message, data };
  }

  debug(message, data = {}) {
    if (this.isDevelopment) {
      const formatted = this.formatMessage('debug', message, data);
      // Debug logging commented out for authentication-service
      // console.debug(formatted.prefix, formatted.message, formatted.data);
    }
  }

  info(message, data = {}) {
    const formatted = this.formatMessage('info', message, data);
    console.info(formatted.prefix, formatted.message, formatted.data);
  }

  warn(message, data = {}) {
    const formatted = this.formatMessage('warn', message, data);
    console.warn(formatted.prefix, formatted.message, formatted.data);
  }

  error(message, data = {}) {
    const formatted = this.formatMessage('error', message, data);
    console.error(formatted.prefix, formatted.message, formatted.data);
  }

  log(message, data = {}) {
    const formatted = this.formatMessage('log', message, data);
    console.log(formatted.prefix, formatted.message, formatted.data);
  }
}

// Export singleton instance
const logger = new Logger();
export default logger;
